/* LiberNovo — selectorul de model ca pe eMAG/Amazon (docs/seo/plan-pagini-pe-model.md, C4).

   Se incarca DOAR cand familia e pornita pentru vizitator (sectiunea il include atunci).
   Fiecare model e un <a href> real spre pagina lui. La un clic simplu cu stanga:
     - aceeasi pagina (Omni <-> Omni Gen): o preia libernovo-maxis.js, e doar o schimbare
       de varianta (data-lnx-same) — aici nu facem nimic;
     - alta pagina (data-lnx-swap): aducem sectiunea paginii tinta prin Section Rendering
       API, o inlocuim pe loc, actualizam head-ul si URL-ul (pushState), fara reincarcare.
   Orice eroare (timeout 4 s, raspuns fara sectiune, status != 200) -> navigare normala.
   Cmd/Ctrl/Shift/clic-mijloc -> comportamentul normal al browserului (tab nou).

   Prefetch DOAR la intentie (hover, focus, touchstart), niciodata la incarcare: altfel
   Googlebot ar randa fragmente fara canonical.

   Contract cu libernovo-maxis.js: window.LNX = { boot(el), destroy(el) }.
   Contract cu sectiunea: [data-lnx-root] cu data-section-id; insula [data-lnx-data] cu
   "family" (modelele de pe alte pagini si variantele lor) si [data-lnx-head] (titlu,
   descriere, canonical, imagine, handle). */
(function () {
  if (window.__lnxFamilie) return;
  window.__lnxFamilie = true;

  var TIMEOUT = 4000;
  var cache = {};          // url -> Promise<html>
  var failed = {};         // url -> true: prefetch-ul a picat, nu-l mai repetam la fiecare hover
  var busy = false;

  function rootEl() { return document.querySelector('[data-lnx-root][data-lnx-family]') || document.querySelector('[data-lnx-root]'); }
  function sectionOf(root) { return root ? (root.closest('.shopify-section') || root.parentNode) : null; }
  function sectionId(root) {
    if (!root) return '';
    var sid = root.getAttribute('data-section-id');
    if (sid) return sid;
    var s = sectionOf(root);
    return (s && s.id) ? s.id.replace(/^shopify-section-/, '') : '';
  }
  function json(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function dataOf(root) { return json(root && root.querySelector('[data-lnx-data]')) || {}; }
  function headOf(root) { return json(root && root.querySelector('[data-lnx-head]')) || {}; }
  function plainClick(e) { return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && (e.button === undefined || e.button === 0); }
  function swapLink(t) {
    var a = t && t.closest ? t.closest('a[data-lnx-swap]') : null;
    if (!a || a.hasAttribute('data-lnx-same')) return null;
    if (window.Shopify && window.Shopify.designMode) return null;   // in editorul de tema navigam normal
    return a;
  }

  // ---- URL-ul tinta: aceeasi culoare, adancime si pachet la modelul nou, daca exista;
  //      altfel aceeasi adancime + Baza; altfel Baza implicita a linkului (data-lnx-vid) ----
  function targetUrl(a, root) {
    var href = a.getAttribute('href') || '';
    var D = dataOf(root);
    var fam = D.family || {};
    var model = a.getAttribute('data-lnx-swap');
    var mm = (fam.models || []).filter(function (x) { return x.m === model; })[0];
    var idIn = root && root.querySelector('[data-lnx-variant-id]');
    var cur = null;
    if (idIn) cur = (D.variants || []).filter(function (v) { return String(v.id) === String(idIn.value); })[0];
    if (!mm || !mm.v || !mm.v.length || !cur) return href;
    var c = cur.o[1], b = cur.o[2], d = cur.d || '48 cm';
    var V = mm.v; // [id, culoare, pachet, adancime, disponibil]
    var dOK = function (x) { return !x[3] || x[3] === d; };
    var pick = V.filter(function (x) { return x[1] === c && x[2] === b && dOK(x); })[0]
      || V.filter(function (x) { return x[2] === 'Bază' && dOK(x) && x[1] === c; })[0]
      || V.filter(function (x) { return x[2] === 'Bază' && dOK(x) && String(x[0]) === String(a.getAttribute('data-lnx-vid')); })[0]
      || V.filter(function (x) { return x[2] === 'Bază' && dOK(x) && x[4]; })[0]
      || V.filter(function (x) { return x[2] === 'Bază' && dOK(x); })[0];
    var u;
    try { u = new URL(href, location.href); } catch (e) { return href; }
    if (!pick) return u.pathname + u.search;
    // Varianta implicita a paginii tinta, pe un link curat: ramane URL-ul curat (canonicalul).
    if (String(pick[0]) === String(a.getAttribute('data-lnx-vid')) && !u.search) return u.pathname;
    u.searchParams.set('variant', pick[0]);
    return u.pathname + u.search;
  }

  // ---- fetch-ul sectiunii, cu timeout si cache pe URL ----
  function load(url, root) {
    if (cache[url]) return cache[url];
    var sid = sectionId(root);
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', sid);
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var tm = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
    // Timer-ul acopera si corpul raspunsului: un corp blocat dupa antete ar lasa altfel
    // clicul fara raspuns, iar `busy` ar ramane pornit.
    var p = fetch(u.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (r.status !== 200) throw new Error('status ' + r.status);
        return r.text();
      })
      .then(function (html) {
        clearTimeout(tm);
        if (!sid || html.indexOf('data-lnx-data') === -1 || html.indexOf('data-lnx-root') === -1) throw new Error('fara sectiune');
        return html;
      });
    if (!ctrl) {
      // fara AbortController: o cursa cu timeout-ul, ca rezerva sa ruleze oricum
      p = Promise.race([p, new Promise(function (res, rej) { setTimeout(function () { rej(new Error('timeout')); }, TIMEOUT); })]);
    }
    p.catch(function () { clearTimeout(tm); delete cache[url]; failed[url] = true; });
    cache[url] = p;
    return p;
  }

  // ---- head ----
  function setMeta(sel, attr, val) {
    if (val == null) return;
    var m = document.head.querySelector(sel);
    if (m) m.setAttribute(attr, val);
  }
  function applyHead(h) {
    if (!h) return;
    if (h.title) document.title = h.title;
    setMeta('meta[name="description"]', 'content', h.description);
    setMeta('link[rel="canonical"]', 'href', h.canonical);
    setMeta('meta[property="og:title"]', 'content', h.title);
    setMeta('meta[property="og:description"]', 'content', h.description);
    setMeta('meta[property="og:url"]', 'content', h.canonical);
    if (h.image) {
      setMeta('meta[property="og:image"]', 'content', h.image);
      setMeta('meta[property="og:image:secure_url"]', 'content', h.image);
    }
    setMeta('meta[name="twitter:title"]', 'content', h.title);
    setMeta('meta[name="twitter:description"]', 'content', h.description);
  }
  // Formularele de limba/tara trimit inapoi la return_to: dupa o schimbare de model trebuie
  // sa ramai pe modelul nou cand schimbi limba.
  function updateReturnTo() {
    var path = location.pathname + location.search;
    Array.prototype.forEach.call(document.querySelectorAll('input[name="return_to"]'), function (i) { i.value = path; });
  }
  // Scripturile inline din sectiune nu ruleaza cand le punem prin innerHTML. Le rulam noi,
  // fara cele cu src (sunt deja incarcate), fara JSON si fara harta C7 (data-lnx-c7).
  function runInlineScripts(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('script'), function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (old.src || old.hasAttribute('data-lnx-c7')) return;
      if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return;
      var s = document.createElement('script');
      if (type) s.type = type;
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }
  function live(msg) {
    var el = document.querySelector('[data-lnx-live]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-lnx-live', '');
      el.setAttribute('aria-live', 'polite');
      el.className = 'lnx-sr';
      el.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      document.body.appendChild(el);
    }
    el.textContent = '';
    setTimeout(function () { el.textContent = msg || ''; }, 30);
  }
  // Judge.me: widget-ul nou are data-id = produsul nou, dar scriptul lor nu stie ca s-a
  // schimbat pagina. Pana la QA pe DEV nu ne bazam pe o reinitializare: sub widget apare un
  // link „Vezi recenziile" care incarca pagina (url#reviews). Niciodata recenziile
  // produsului anterior — widget-ul vechi a plecat odata cu sectiunea.
  // Dupa pushState, url#reviews difera de URL-ul documentului doar prin ancora, deci un clic
  // simplu ar fi doar un salt in pagina, la widget-ul gol. De aceea clicul reincarca pagina
  // curenta (cu ?variant= de acum, nu cel de la schimbare) si aterizeaza pe #reviews.
  // Cmd/Ctrl-clic ramane la browser: tab nou pe href, deci tot o incarcare completa.
  function reviewsFallback(scope, url, D) {
    var w = scope.querySelector('.jdgm-review-widget');
    if (!w || w.children.length) return;
    var a = document.createElement('a');
    a.href = url.split('#')[0] + '#reviews';
    a.className = 'lnx-rev-link';
    a.setAttribute('data-lnx-rev-link', '');
    a.textContent = ((D && D.i18n && D.i18n.seeReviews) || 'Vezi recenziile') + ' →';
    a.addEventListener('click', function (e) {
      if (!plainClick(e)) return;
      e.preventDefault();
      var to = location.pathname + location.search + '#reviews';
      a.setAttribute('href', to);
      try { history.scrollRestoration = 'manual'; history.replaceState(history.state, '', to); } catch (er) {}
      location.reload();
    });
    w.parentNode.insertBefore(a, w.nextSibling);
  }
  function track(oldH, h, url) {
    try {
      var A = window.ErgolivAnalytics;
      if (A) {
        if (!A.product) A.product = {};
        A.product.handle = h.handle;
        A.product.title = h.productTitle || h.title;
        A.product.price = h.price;
        A.product.familie = h.familie;
        A.product.model = h.model;
        A.product.adancime = h.depth;
      }
    } catch (e) {}
    // page_viewed / product_viewed nu se mai declanseaza fara reincarcare; compensam.
    try { if (window.ergolivTrack) window.ergolivTrack('lnx_model_switch', h.handle, { din: oldH || '', model: h.model || '', familie: h.familie || '', adancime: h.depth || '' }); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('lnx_model_view', { handle: h.handle, productId: h.id, model: h.model, depth: h.depth, familie: h.familie, url: url });
      }
    } catch (e) {}
  }

  // ---- inlocuirea ----
  function swap(url, opts) {
    opts = opts || {};
    var root = rootEl();
    var sec = sectionOf(root);
    if (!root || !sec) return Promise.reject(new Error('fara radacina'));
    var oldHandle = root.getAttribute('data-lnx-handle') || '';
    return load(url, root).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSec = doc.getElementById(sec.id) || doc.querySelector('.shopify-section') || doc.body;
      var newRoot = newSec && newSec.querySelector('[data-lnx-root]');
      if (!newRoot || !newRoot.querySelector('[data-lnx-data]')) throw new Error('fara insula');
      // Pagina tinta fara familie (ex. seria oprita intre timp) sau fara head: n-am avea
      // titlu si canonical de pus, deci navigam normal.
      if (!newRoot.hasAttribute('data-lnx-family') || !newRoot.querySelector('[data-lnx-head]')) throw new Error('fara familie');
      var head = headOf(newRoot);
      var y = window.pageYOffset || 0;

      if (window.LNX) window.LNX.destroy(root);
      sec.innerHTML = newSec.innerHTML;
      var nr = sec.querySelector('[data-lnx-root]');

      if (opts.push) { try { history.pushState({ lnx: 1, y: y }, '', url); } catch (e) { location.assign(url); return; } }
      applyHead(head);
      updateReturnTo();
      runInlineScripts(sec);
      if (window.LNX) window.LNX.boot(nr);
      // Celelalte scripturi din sectiune (video-ul creatorului, animatiile) se re-agata la
      // evenimentul pe care il trimite si editorul de tema dupa o re-randare; LNX e deja
      // pornit, iar init-ul lui e pazit, deci nu porneste de doua ori.
      try { sec.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId(nr) } })); } catch (e) {}
      var D = dataOf(nr);
      reviewsFallback(sec, url, D);

      // scroll stabil; din tabelul de comparatie urcam la buy box, ca pana acum
      if (opts.top) { var top = nr.getBoundingClientRect().top + window.pageYOffset; window.scrollTo({ top: Math.max(0, top - 20), behavior: 'smooth' }); }
      else window.scrollTo(0, typeof opts.y === 'number' ? opts.y : y);
      if (opts.model) {
        var f = nr.querySelector('[data-lnx-model="' + (window.CSS && CSS.escape ? CSS.escape(opts.model) : opts.model) + '"]');
        if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
      }
      live(head.model || head.title || '');
      track(oldHandle, head, url);
      currentPath = location.pathname;
    });
  }

  var currentPath = location.pathname;

  // la incarcare: intrarea curenta devine a noastra, ca Inapoi sa o poata reface
  try {
    var st0 = {};
    if (history.state && typeof history.state === 'object') { for (var k in history.state) st0[k] = history.state[k]; }
    st0.lnx = 1;
    history.replaceState(st0, '');
  } catch (e) {}

  // ---- clic ----
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || !plainClick(e)) return;
    var a = swapLink(e.target);
    if (!a) return;
    var root = rootEl();
    if (!root || !window.fetch || !window.DOMParser || !history.pushState) return;
    // In timpul unei inlocuiri: al doilea clic pe acelasi link e ignorat; clicul pe alt
    // model merge la browser (navigare normala), nu se pierde.
    if (busy) { if (a.getAttribute('aria-busy') === 'true') e.preventDefault(); return; }
    e.preventDefault();
    busy = true;
    var url = targetUrl(a, root);
    var model = a.getAttribute('data-lnx-swap');
    var fromCmp = a.hasAttribute('data-lnx-cmp-btn');
    a.setAttribute('aria-busy', 'true');
    swap(url, { push: true, model: model, top: fromCmp })
      .catch(function () { location.assign(url); })
      .then(function () { busy = false; a.removeAttribute('aria-busy'); });
  });

  // ---- prefetch doar la intentie ----
  function intent(e) {
    var a = swapLink(e.target);
    if (!a) return;
    var root = rootEl();
    if (!root || !window.fetch) return;
    var url = targetUrl(a, root);
    if (failed[url]) return;
    load(url, root).catch(function () {});
  }
  document.addEventListener('mouseover', intent, { passive: true });
  document.addEventListener('focusin', intent);
  document.addEventListener('touchstart', intent, { passive: true });

  // ---- Inapoi / Inainte ----
  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.lnx) return;
    if (location.pathname === currentPath) return;   // aceeasi pagina (ex. o ancora): nimic de inlocuit
    swap(location.pathname + location.search, { push: false, y: e.state.y }).catch(function () { location.reload(); });
  });
})();
